import React from "react";
import { css } from "emotion";
import GenericCard from "../GenericCard";
import { boxStyles, colors, textSizes } from "../../styles/theme";
import GenericTextInput from "../GenericTextInput";

const CustomButton = ({ ctaText, setCtaText, linkVal, setLinkVal }) => {
  return (
    <GenericCard style={customButton}>
      <div className="input-box btn-title">
        <p className="title">TEXT</p>
        <GenericTextInput
          placeholder="Contact Us"
          style="title-input"
          value={ctaText}
          onValueChange={setCtaText}
          maxLength={12}
        />
      </div>
      <div className="input-box">
        <p className="title">LINK</p>
        <GenericTextInput
          placeholder="https://"
          needsCounter={false}
          value={linkVal}
          onValueChange={setLinkVal}
        />
      </div>
    </GenericCard>
  );
};

export default CustomButton;

const customButton = css`
  box-sizing: border-box;
  flex-direction: column;
  padding: ${boxStyles.standardPadding};
  width: 100%;

  .input-box {
    width: 100%;
    margin-bottom: 10px;

    .title {
      color: ${colors.placeholderText};
      font-size: 10px;
      padding-bottom: 2px;
    }
    .title-input {
      box-sizing: border-box;
    }
  }

  .btn-title {
    width: 40%;
  }

  @media screen and (min-width: ${boxStyles.desktopBreak}) {
    flex-direction: row;
    justify-content: space-between;
    .input-box {
      width: 60%;
    }
    .btn-title {
      width: 30%;
    }
  }
`;
